import { ReactNode } from 'react';

import WithTwClassName from '../../hoc/WithTwClassName';

import FullScreenLoadingSpinner from '../fullScreenLoadingSpinner/FullScreenLoadingSpinner';
import TermsOfServiceModal from '../termsOfServiceModal/TermsOfServiceModal';
import styles from './Page.module.scss';

interface IPageProps {
  bannerSticky?: boolean;
  className?: string;
  children: ReactNode;
  hideLoader?: boolean;
  loading?: boolean;
  loaderVariant?: 'default' | 'circular';
  requireTermsOfServiceConsents?: boolean;
  pageBackground?: 'transparent' | 'dark' | 'regular' | 'store';
  withScrollbar?: boolean;
}

const Page = ({
  bannerSticky = true,
  children,
  className = '',
  hideLoader = false,
  loading = false,
  loaderVariant = 'default',
  pageBackground = 'regular',
  requireTermsOfServiceConsents = false,
  withScrollbar = false,
}: IPageProps) => {
  const pageClasses = [
    styles['page'],
    styles[`page--${pageBackground}`],
    withScrollbar ? styles[`page--scrollable`] : '',
    className,
  ];

  return (
    <>
      {requireTermsOfServiceConsents ? <TermsOfServiceModal /> : <></>}
      {hideLoader ? <></> : <FullScreenLoadingSpinner loading={loading} loaderVariant={loaderVariant} />}
      <div className={pageClasses.join(' ')}>{children}</div>
    </>
  );
};

export default WithTwClassName(Page);
